import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line no-unused-vars
const useContainerStyles = (_props = {}) => {
  const useStyles = makeStyles({
    searchCardWrapper: {
      marginBottom: '30px',
      padding: '24px',
      alignContent: 'center'
    },
    searchWrapper: {
      display: 'flex',
      gap: '25px',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    mainSection: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    },
    mainContainer: {
      marginTop: '100px',
      paddingLeft: '15px',
      overflow: 'auto',
      height: 'calc(100vh - 100px)',
      paddingTop: '13px'
    }
  });

  return useStyles();
};

export default useContainerStyles;
